import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JsonObjectFactoryService } from '../../../global/services/json-object-factory.service';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TemplatesService {
  private readonly baseUrl = environment.base_url;
  private readonly adminApiUrl = environment.admin_api_url;

  constructor(
    private http: HttpClient,
    private jsonObjectFactory: JsonObjectFactoryService,
  ) {}

  // --- Template Type ---

  getTemplateTypeDetail(templateTypeKey: number | string): Observable<any> {
    return this.jsonObjectFactory.getJSONObj(
      `${this.baseUrl}/loadJsonObject`,
      { action_code: '0a8qkl', template_type_key: String(templateTypeKey) },
      undefined,
      undefined,
      { silent: true },
    );
  }

  saveTemplateType(payload: any[], isEdit: boolean): Observable<any> {
    const actionCode = isEdit ? 'ryf88q' : 'txxeu7';
    const url = `${this.baseUrl}/saveJsonObject?action_code=${actionCode}`;
    const data: any = {
      jsonObj: JSON.stringify(payload),
      jsonSettings: '{}',
    };
    return this.jsonObjectFactory.saveJSON(url, data);
  }

  // --- Template ---

  getTemplateDetail(templateKey: number | string): Observable<any> {
    return this.jsonObjectFactory.getJSONObj(
      `${this.baseUrl}/loadJsonObject`,
      { action_code: '916d9i', template_key: String(templateKey) },
      undefined,
      undefined,
      { silent: true },
    );
  }

  getActiveTemplateTypes(): Observable<any> {
    return this.jsonObjectFactory.getJSONObj(
      `${this.baseUrl}/loadJsonObject`,
      { action_code: '4txmy1', fetch_type: '1' },
      undefined,
      undefined,
      { silent: true },
    );
  }

  getJurisdictionsByClient(clientKey: string | number): Observable<any> {
    const fd = new FormData();
    fd.append('clientkey', String(clientKey));
    return this.http.post<any>(
      `${this.baseUrl}/loadJsonObject?action_code=x5hvpy`,
      fd,
      { withCredentials: true },
    );
  }

  saveTemplate(payload: any[], isEdit: boolean): Observable<any> {
    const actionCode = isEdit ? 'csx7p4' : '5so839';
    const url = `${this.baseUrl}/saveJsonObject?action_code=${actionCode}`;
    const data: any = {
      jsonObj: JSON.stringify(payload),
      jsonSettings: '{}',
    };
    return this.jsonObjectFactory.saveJSON(url, data);
  }

  // --- Module Assignment (Step 2) ---

  getGtwModules(data: { jurisdiction_key: number; client_key: any; row_primary_key: any }): Observable<any> {
    return this.http.post<any>(`${this.adminApiUrl}/getGtwModules`, data, { withCredentials: true });
  }

  setModuleAccess(
    nodes: { jcd_ta_key: any; jcd_ta_role_key: any; user_id: any; client_key: any }[],
    templateKey: any,
  ): Observable<any> {
    const fd = new FormData();
    fd.append('data', JSON.stringify(nodes));
    return this.http.post<any>(
      `${this.adminApiUrl}/setModuleAccess?template_key=${templateKey}`,
      fd,
      { withCredentials: true },
    );
  }

  getTemplateModuleCount(data: { template_key: any; logged_in_user_sso_id: any }): Observable<any> {
    return this.http.post<any>(`${this.adminApiUrl}/getTemplateModuleCount`, data, { withCredentials: true });
  }
}
